import { Component, Input } from '@angular/core';
import { IconComponent } from '@nagel-assests';

@Component({
    selector: 'lib-temperature-icon',
    imports: [IconComponent],
    templateUrl: './temperature-icon.component.html',
    styleUrl: './temperature-icon.component.scss'
})
export class TemperatureIconComponent {
  @Input() temperature!: number;

  getIconByTemperature(temp: number): string {
      let iconName = '';
      const LEAF_TEMPERATURE = 10;
      if (!isNaN(temp)) {
          if (temp < 0) {
              iconName = 'strawberry_icon';
          } else if (temp > 0 && temp < LEAF_TEMPERATURE) {
              iconName = 'leaf_icon';
          } else {
              iconName = 'snowflake_icon';
          }
      }
      return iconName;
  }
}